import PropTypes from 'prop-types'

import sinfoto from '../../../src/img/sinfoto.jpg'

const Imagen = ({ width, height, className = '', adjunto, loadingImagenes }) => {
  return loadingImagenes ? (
    <div className="spinner-border text-secondary" role="status">
      <span className="visually-hidden">Cargando...</span>
    </div>
  ) : (
    <img
      src={adjunto?.url || sinfoto}
      width={width}
      height={height}
      loading="lazy"
      alt={adjunto?.nombre || 'Sin foto'}
      className={className}
    />
  )
}

Imagen.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  adjunto: PropTypes.shape({
    url: PropTypes.string,
    nombre: PropTypes.string
  }),
  loadingImagenes: PropTypes.bool
}

export default Imagen
